import React from "react";

const ErrorDialog = ({ title = "Error", message, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative z-10 w-full max-w-md rounded-xl bg-white shadow-xl border border-slate-200 p-6">
        <div className="flex items-start gap-3">
          <div className="mt-1 h-6 w-6 flex items-center justify-center rounded-full bg-red-100 text-red-600">
            !
          </div>
          <div>
            <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
            {message && (
              <p className="mt-2 text-slate-600 text-sm leading-relaxed">
                {message}
              </p>
            )}
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="inline-flex items-center px-4 py-2 rounded-md bg-red-600 text-white text-sm font-medium hover:bg-red-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorDialog;
